/**
 * Identifies a tab/page within the settings modal.
 *
 * These values appear in the URL as `?settings=<value>`, e.g.
 * `/notes?settings=zapier` or `/notes/note-123?settings=profile`.
 */
export enum SettingsTabId {
  PersonalPage = "personal",
  NotificationPreferencesPage = "notification-preferences",
  VoiceModePage = "voice-mode",
  ChatPage = "chat",
  SubscriptionManagementPage = "subscription-management",
  ReferralProgramPage = "referral-program",
  AccountManagementPage = "account-management",
  DebugAccountPage = "debug-account-management",
  DebugSandboxPage = "debug-sandbox",
  ExportsPage = "export",
  ImportsPage = "imports",
  ApiKeysPage = "api-keys",
  TemplatesPage = "templates",
  AppearancePage = "appearance",
  EditorPage = "editor",
  CalendarAndMeetingsPage = "calendar-and-meetings",
  ChromeExtensionPage = "chrome-extension",
  EmailToMemPage = "email-to-mem",
  ZapierPage = "zapier",
  McpPage = "mcp",
  ConnectedToolsPage = "connected-tools",
  MemAgentPage = "mem-agent",
  MemAgentCommunicationChannelsPage = "mem-agent-communication-channels",
  ProfilePage = "profile",
  UsagePage = "usage",
}
